<template>
    <div class="story-form-post-creator hide-scrollbar" ref="scrollableDiv">
         <!-- //////////////  Standard mode  //////////////-->
        <section class="publish-date" v-if="!isSharedStory">
            <label>
                {{ $t('dash.post-creator.form.publish-date') }} 
                <span v-if="storySelected.planifiedDate.isEdited()" @click="storySelected.planifiedDate.restore" class="restore">
                    {{ $t('dash.post-creator.form.cancel-changes') }}
                </span>
            </label>
            <div class="content-section">
                <SelectComponent 
                    :changeValueSelect="changeSelectPublishDate" 
                    :data="{now: $t('dash.post-creator.form.now'),flanified: $t('dash.button.schedule')}" 
                    :valueSelect="!storySelected.planifiedDate.date ? 'now' : 'flanified'" 
                    :positionAuto="false" :positionX="'left'"
                />
                <template v-if="storySelected.planifiedDate.date">
                    <div class="input-date">        
                        <p>{{ storySelected.planifiedDate.dayDynamicLabel }}</p>
                        <i class="fa-regular fa-calendar"></i>
                        <input
                            type="date" 
                            v-model="models.date" 
                            :disabled="!storySelected.planifiedDate.date" 
                            @click="(e)=>e.target.showPicker()"
                            @change="setDate"
                            :min="new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')"
                        >
                    </div>
                    <div class="input-hours">
                        <VueTimepicker 
                            v-model="models.hours" 
                            manual-input
                            @close="setDate"
                        />
                        <i class="fa-regular fa-clock"></i>
                    </div>
                </template>
            </div>
        </section>
        <!-- /////////////////////////////////////////////-->

        <section class="content-media">
            <label>
                {{ $t('dash.post-creator.story.background') }} 
                <span 
                    v-if="storySelected.background.isEdited()" 
                    @click="storySelected.background.restore" 
                    class="restore"
                >
                    {{ $t('dash.post-creator.form.cancel-changes') }}
                </span>
            </label>
            <div class="container-medias">
                <div class="btn-color" 
                    @click="()=>{colorPickerShow = true; showPipette = true}" 
                    :style="{ background: storySelected.background.color }"
                >
                    <div 
                        class="picker-color" 
                        v-if="colorPickerShow" 
                        @mouseleave="()=>{colorPickerShow = false}" 
                        @mousedown="showPipette = false"
                    >
                        <div 
                            class="icon-pipette" 
                            v-if="eyeDropperIsAccess && showPipette" 
                            @mousedown.stop 
                            @click.stop="startEyeDropper"
                        ></div>
                        <chrome-picker :value="{hex: storySelected.background.color}" @input="updateFromPicker"/>
                    </div>
                </div>

                <template v-if="!isSharedStory">
                    <input
                        v-validate="''"
                        name="file"
                        type="file"
                        id="file"
                        ref="inputMediaStory"
                        @change="uploadBackgroundFile"
                        :multiple="false"
                        @click="()=>{}"
                        :accept="'.jpg, .jpeg, .png, .webp, .mp4, .gif, .webm, .ogg, .avi, .wmv, .flv, .mkv, .mov'"
                        hidden
                    >         
                    <DropFile :targetInput="$refs.inputMediaStory"/>
                    <!-- .avi, .mov, .mkv -->

                    <template v-if="storySelected.background.file">
                        <div class="media-container picture" v-if="storySelected.background.file.info.type2 == 'image'" @click="openBackgroundResizeMode">
                            <i class="fa-solid fa-circle-xmark" @click.stop="removeBackgroundFile"></i>
                            <div class="media picture">
                                <img draggable="false" :src="storySelected.background.file.url" alt="" class="source">
                            </div>
                        </div>

                        <div class="media-container video" v-else-if="storySelected.background.file.info.type2 == 'video'" @click="openBackgroundResizeMode">
                            <i class="fa-solid fa-circle-xmark" @click.stop="removeBackgroundFile"></i>
                            <div class="media video"> 
                                <video 
                                    muted loop playsinline preload="metadata" class="source" 
                                    onloadedmetadata="this.muted = true"
                                    :src="storySelected.background.file.url" 
                                    :type="storySelected.background.file.info.type"
                                >
                                </video>
                            </div>
                        </div>
                    </template>
                    

                    <div class="btn-add-media" v-else @click="clickBtnAddMedia">
                        <i class="fa-solid fa-photo-film"></i>
                    </div>
                </template>


            </div>
        </section>

        <section class="content-stickers">
            <label>
                {{ $t('dash.post-creator.story.stickers') }} 
                <span 
                    v-if="storySelected.stickers.isEdited()" 
                    @click="storySelected.stickers.restore" 
                    class="restore"
                >
                    {{ $t('dash.post-creator.form.cancel-changes') }}
                </span>
            </label>
            <div class="container-stickers">
                <draggable
                    class="list-stickers hide-scrollbar"
                    ref="listStickers"
                    v-model="storySelected.stickers.items"
                    v-bind="dragOptions"
                    @start="drag=true"
                    @end="onDragStickerEnd"
                    :filter="'.lockdrag'"
                >
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        <template v-for="(sticker, index) in storySelected.stickers.items">
                            <div 
                                v-if="false && sticker.id == 'btnAdd'" 
                                @click="openMenuStickers" 
                                class="btn-add-sticker lockdrag" 
                                :class="{'no-drag' : drag}" 
                                :key="'btnAdd'"
                            >
                                <svg width="auto" height="auto" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6667 0H31.3333C38.3289 0 44 5.67106 44 12.6667V25.1242C44 26.5387 43.4381 27.8952 42.4379 28.8954L28.8954 42.4379C27.8952 43.4381 26.5387 44 25.1242 44H12.6667C5.67106 44 0 38.3289 0 31.3333V12.6667C0 5.67106 5.67106 0 12.6667 0ZM12.6667 4C7.8802 4 4 7.8802 4 12.6667V31.3333C4 36.1198 7.8802 40 12.6667 40H25.3333L40 25.3333V12.6667C40 7.8802 36.1198 4 31.3333 4H12.6667Z" fill="#F1EDF5"/>
                                    <path d="M35.334 23.334H43.334L41.334 27.334H35.334C30.9157 27.334 27.334 30.9157 27.334 35.334V40.6673L23.334 41.334V35.334C23.334 28.7066 28.7066 23.334 35.334 23.334Z" fill="#F1EDF5"/>
                                    <path d="M16.6673 18.0007C16.6673 19.4734 15.4734 20.6673 14.0007 20.6673C12.5279 20.6673 11.334 19.4734 11.334 18.0007C11.334 16.5279 12.5279 15.334 14.0007 15.334C15.4734 15.334 16.6673 16.5279 16.6673 18.0007Z" fill="#F1EDF5"/>
                                    <path d="M32.6673 18.0007C32.6673 19.4734 31.4734 20.6673 30.0007 20.6673C28.5279 20.6673 27.334 19.4734 27.334 18.0007C27.334 16.5279 28.5279 15.334 30.0007 15.334C31.4734 15.334 32.6673 16.5279 32.6673 18.0007Z" fill="#F1EDF5"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9633 26.2096C13.7676 25.4526 15.0334 25.4909 15.7904 26.2953C17.9806 28.6224 20.4661 29.1591 22.4662 29.1247C23.4806 29.1072 24.3615 28.9402 24.986 28.7775C25.2962 28.6967 25.5372 28.6185 25.6927 28.5638C25.7703 28.5365 25.8261 28.5152 25.8581 28.5027C25.874 28.4965 25.884 28.4924 25.8876 28.4909L25.8852 28.492L25.8826 28.4931M25.8881 28.4907C26.9014 28.062 28.0717 28.5325 28.5056 29.5448C28.9407 30.5601 28.4704 31.7359 27.4552 32.171L26.675 30.3507C27.4552 32.171 27.4543 32.1714 27.4534 32.1718L27.4514 32.1726L27.4469 32.1745L27.4361 32.1791L27.4065 32.1913C27.3834 32.2008 27.3534 32.2129 27.3168 32.2273C27.2435 32.2559 27.1437 32.2936 27.0195 32.3373C26.7715 32.4245 26.4239 32.5364 25.9945 32.6483C25.1398 32.871 23.9374 33.0999 22.5351 33.1241C19.7019 33.1729 16.0207 32.3763 12.8776 29.0368C12.1206 28.2324 12.1589 26.9667 12.9633 26.2096M25.8881 28.4907C25.888 28.4908 25.8878 28.4909 25.8876 28.4909L25.8884 28.4906L25.8892 28.4903C25.889 28.4904 25.8887 28.4905 25.8881 28.4907Z" fill="#F1EDF5"/>
                                </svg>
                            </div>
                            <div 
                                v-else 
                                class="stricker" 
                                @click="()=>clickSticker(index)" 
                                :class="{'lockdrag' : ['music','post'].includes(sticker.type), 'no-drag' : drag && sticker.type == 'post'}" 
                                :key="index"
                            >
                                <i v-if="sticker.type !== 'post'" class="fa-solid fa-circle-xmark" @click.stop="sticker.delete"></i>
                                <div class="sticker-view">

                                    <Tooltip
                                        v-if="sticker.type == 'music'"
                                        :text="sticker.data.music && (sticker.data.music.track ? sticker.data.music.track.title : sticker.data.music.original_sound.title)" 
                                        position="bottom"
                                        classCustom="music"
                                    >
                                        <div class="disk">
                                            <img :src="sticker.data.music.track ? sticker.data.music.track.cover_artwork_thumbnail_uri : sticker.data.original_sound.ig_artist.profile_pic_url">
                                        </div>
                                    
                                    </Tooltip>

                                    <stickerWrapper v-else
                                        :stickerInstance="sticker"
                                        :story="storySelected"
                                        :sticker="{...sticker}"
                                    />
                                </div>
                                <p class="sticker-type">{{sticker.type}}</p>
                            </div>
                        </template >
                       
                    </transition-group>
                </draggable>
            </div>
        </section>

        <section class="content-facebook" v-if="!isSharedStory">
            <label>Facebook</label>
            <div class="type-switch">
                {{ $t('dash.post-creator.story.share-on-facebook') }}

                <ComponentSwitch :value="storySelected.shareInFacebook" :onChange="handlerSharePostInStoryFacebook" :id="'switch-share-story'"/>
 
            </div>
        </section>
    </div>
</template>

<script>

import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import SelectComponent from '@/components/dash/utils/select.vue'
import ComponentSwitch from '@/components/dash/utils/switch.vue'
import Checkbox from '@/components/dash/utils/checkbox.vue'
import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'

import draggable from 'vuedraggable'
import minxinBot from '@/components/mixins/Bots.vue'
import minxinPosts from '@/components/mixins/Posts.vue'
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
import stickerWrapper from './storyMaker/stiker/stickerWrapper.vue';
import { Chrome } from 'vue-color'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import DropFile from '@/components/dash/DropFile.vue'
import { VueDraft } from '@mashupweb/draft-lib';
import StoryForm from '@mashupweb/draft-lib/dist/form/story/Form';
import { Story } from '@mashupweb/draft-lib/dist/form/story/entities/story';
// import * as pdfjsLib from 'pdfjs-dist/webpack';

// // Configure the workerSrc to use the correct version of the worker script
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js`;


export default {
    mixins: [minxinBot, minxinPosts],
    components: {
        SelectComponent,
        ComponentSwitch,
        Checkbox,
        Tooltip,
        ContextMenu,
        draggable,
        stickerWrapper,
        'chrome-picker': Chrome,
        VueTimepicker,
        DropFile
    },

    props: {
        typeRenderNetworkSelected: {
            type: String,
            default: 'facebook'
        },

        idPageRenderNetworkSelected: String,
        
        
        personalizationMode : {
            type: Boolean,
            default: false
        },

        uploadFilesServer : {
            type: Object,
            default: () => ({})
        },

        idStorySelected: {
            type: String,
            default: '0'
        },
        

        files:Object,
        tab: String,
        indexStorySelected: {
            type: Number,
            default: 0
        },
        formInstance: StoryForm,
        storySelected: Story,
        
        isSharedStory: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            lastModeSelected : undefined,
            drag : false,
            timeoutVerifMetaUrl: null,

    

            eyeDropperIsAccess : false,
            colorPickerShow: false,
            colorPickerShow: false,
            showPipette: false,

            models: {
                date: null,
                hours: null,
            }
        }
    },

    created () {

    },

    mounted () {
       
       this.eyeDropperIsAccess = window.EyeDropper ? true : false
    },

    methods: {
        addMode(mode, data = {}) {
            this.lastModeSelected = mode
            EventBus.$emit("postCreatorAddMode", mode, data);
        },

        setDate() {
            const [ hours, minutes ] = this.models.hours.split(':')
            const [ year, month, day ] = this.models.date.split('-')

            let newDate = new Date()
            newDate.setHours(parseInt(hours), parseInt(minutes))
            newDate.setFullYear(parseInt(year), parseInt(month)-1, parseInt(day))

            this.storySelected.planifiedDate.setDate(newDate)
        },
            
        changeSelectPublishDate(value) {
            if (value == "flanified") {
                this.storySelected.planifiedDate.setDate(new Date())
            }else if(value == "now") {
                this.storySelected.planifiedDate.setDate(null)
            }  
        },

 

        clickBtnAddMedia() {
           this.$refs.inputMediaStory.click()
        },

        async uploadBackgroundFile(event) {
            const file = event.target.files[0];
            if (file) {
                this.storySelected.background.upload(
                    file, 
                    {
                        onLocalReady: () => this.openBackgroundResizeMode()
                    }
                )
            }
        },
 
        removeBackgroundFile() {
            this.storySelected.background.fileId = null
            this.storySelected.background.resetDraggable()
        },

        clickBtnAddVideoPreview(id) {
            this.$refs.inputVideoPreview.setAttribute('idMedia', id)
            this.$refs.inputVideoPreview.click()
        },

        handlerSharePostInStoryFacebook(state) {
            this.storySelected.shareInFacebook = state
        },

        async fileToArrayBuffer(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();

                reader.onload = function(e) {
                    let arrayBuffer = new Uint8Array(reader.result);
                    resolve(arrayBuffer)
                }

                reader.readAsArrayBuffer(file);
            });
        },

       

        onDragStickerEnd(event) {
            this.storySelected.stickers.sort()            
            this.drag=false
            EventBus.$emit("storyMaker-setOverlay", false)
        },

        deleteSticker(index) {
            this.storySelected.stickers.deleteByIndex(index)    
        },

        clickSticker(id) {
            alert('clickSticker a revoir')
            const sticker = null
            const typeStikerEdited = ['survey', 'text', 'slider', 'music', 'mention', 'hashtag', 'product', 'link']
            if (sticker) {
                if (typeStikerEdited.includes(sticker.type)) {
                   
                }
            }
        },

        openBackgroundResizeMode() {
            if (this.storySelected.background?.file.info.type2 == 'image') {
                EventBus.$emit("storyMaker-setOverlay", 'backgroundResize')
            }
        },

        openMenuStickers() {
            EventBus.$emit("storyMaker-setOverlay", 'stickers')
        },

        updateFromPicker(value) {
            this.storySelected.background.color = value.hex
        },

        startEyeDropper() {
            if (!window.EyeDropper) return
            
            this.colorPickerShow = false
            const eyeDropper = new EyeDropper();

            eyeDropper.open().then((result) => {
                this.storySelected.background.color = result.sRGBHex
            }).catch((e) => {
            });
        },

    },

    computed: {
        form() {
            return this.formInstance
        },
        console: () => console,

        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
       
    },

    watch: {

    },

}




</script>